<template>
  <b-card title="Edit Sparepart">
    <b-row>
      <b-col cols="12" class="text-center mb-3">
        <b-img :src="form.image || noImageURL" fluid rounded style="width: 150px; height: 150px; object-fit: cover;"></b-img>
        <b-form-file v-model="newImage" accept="image/*" @change="uploadImage" class="mt-2"></b-form-file>
      </b-col>
      <b-col cols="12">
        <b-form @submit.prevent="saveItem">
          <b-form-group id="model" label="Model" label-for="model" description="Item Model">
            <b-form-input disabled id="input-model" v-model="form.itemModel" type="text" placeholder="Enter item model" required></b-form-input>
          </b-form-group>

          <b-form-group id="description" label="Description" label-for="description" description="Description">
            <b-form-input disabled id="input-description" v-model="form.description" type="text" placeholder="Enter description" required></b-form-input>
          </b-form-group>

          <b-form-group label="Product Hierarchy" description="Product Hierarchy">
            <b-form-input disabled id="input-productHierarchy" v-model="form.productHierarchy" type="text" placeholder="Enter Hierarchy"></b-form-input>
          </b-form-group>
          <b-form-group label="Location" description="Location">
            <b-form-input disabled id="input-location" v-model="form.location" type="text" placeholder="Enter Location"></b-form-input>
          </b-form-group>

          <b-form-group v-if="!form.productHierarchy.startsWith('05300')" label="Category" label-for="category" description="Category">
            <v-select 
              id="category" 
              v-model="selectedCategory" 
              :options="categoryOptions" 
              label="text"  
              multiple
              @input="categorySelected"
            />
          </b-form-group>

          <b-form-group v-if="!form.productHierarchy.startsWith('05300')" label="Replacement Item" label-for="replacement-item" description="Replacement Item">
            <v-select
              id="replacement-item"
              v-model="selectedReplacement"
              :options="replacementOptions"
              label="text"
              multiple
              @input="replacementSelected"
            ></v-select>
          </b-form-group>
          <b-button type="submit" variant="primary">Save</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import axios from '@/axios';
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      form: {},
      newImage: null,
      noImageURL: require('@/assets/images/no-image.png'),
      category: null,
      categoryOptions: [],
      selectedCategory: [],
      selectedReplacement: [],
      replacementOptions: []
    };
  },
  mounted() {
    this.getItemDetail();
  },
  computed: {},
  methods: {
    ...mapActions({}),
    getItemDetail() {
      axios.get(`sales-and-purchase/drcc/item/detail/${this.$route.params.id}`).then((response) => {
        let item = response.data.data;
        item.status = item.status === '' ? 'Active' : 'Inactive';
        this.form = item;
        const product = item.productHierarchy;
        console.log("🚀 ~ axios.get ~ item:", item)
        
        if (product.includes('05100')) {
          if (item.categorySparepart.length > 0) {
            // this.categoryOptions = item.categorySparepart.map((item) => item.name)
            this.selectedCategory = item.categorySparepart.map((item) => {
              return { text: item.name, value: item.id }
            })
          }
          this.category = 'sparepart'
          if (item.replacementItem.length > 0) {
            this.selectedReplacement = item.replacementItem.map((item) => {
              return { text: item.itemModel, value: item._id }
            })
          }
        }else if (product.includes('10000')) {
          if (item.categoryAccessories.length > 0) {
            // this.categoryOptions = item.categoryAccessories.map((item) => item.name)
            this.selectedCategory = item.categoryAccessories.map((item) => {
              return { text: item.name, value: item.id }
            })
          }
          this.category = 'accessories'
        }        
        this.getOptions()
        this.getReplacementOptions()
      }).catch((e) => {
        console.log(e);
      });
    },
    uploadImage(event) {
      const file = event.target.files[0];
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
      const maxSize = 1 * 1024 * 1024;

      if (file) {
        if (!allowedTypes.includes(file.type)) {
          this.$bvToast.toast('Only PNG, JPG, and JPEG files are allowed.', {
            variant: 'danger',
            solid: true
          });
          return;
        }

        if (file.size > maxSize) {
          this.$bvToast.toast('Maximum file size is 1MB.', {
            variant: 'danger',
            solid: true
          });
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          this.form.image = e.target.result; // Langsung tampilkan gambar
        };
        reader.readAsDataURL(file);
      }
    },
    saveItem() {
      const payload = {
        image: this.form.image,
        category: this.category,
        selected: this.selectedCategory.map(x => x.value),
        replacement: this.selectedReplacement.map(x => x.value),
      }
      axios.put(`sales-and-purchase/drcc/item/update/${this.$route.params.id}`, payload)
        .then(() => {
          sessionStorage.setItem("toastMessage", "Item updated successfully");
          this.$router.push({ name: 'sparepart-master' });
        })
        .catch((e) => {
          console.log(e);
          sessionStorage.setItem("toastMessage", "Item Updated Failed");
          this.$router.push({ name: 'sparepart-master' });
        });
    },
    getOptions() {
      axios.get(`sales-and-purchase/category/select-options`, {
        params: {
          category: this.category
        }
      }).then((response) => {
        this.categoryOptions = response.data.data.map((x) => {
          return { text: x.name, value: x.id };
        });
      }).catch((e) => {
        console.log(e);
      });
    },
    getReplacementOptions() {
      axios.get(`sales-and-purchase/drcc/items-filter`, {
        params: {
          type: this.category,
          options: '1'
        }
      }).then((response) => {
        this.replacementOptions = response.data.data.map((x) => {
          return { text: x.itemModel, value: x._id };
        });

        console.log('asd',this.replacementOptions);
        
      }).catch((e) => {
        console.log(e);
      });
    },
    categorySelected(values) {
      this.selectedCategory = values.map(v => {
        return { text: v.text, value: v.value };
      });
    },
    replacementSelected(values) {
      this.selectedReplacement = values.map(v => {
        return { text: v.text, value: v.value };
      });
    },
  }
};
</script>